import { useCallback } from "react";

import { useState } from "react";
import type { LayoutChangeEvent } from "react-native";
import { View } from "react-native";
import useAIFeedbackStore from "../hooks/useAIFeedbackStore";
import { type SlideData, Slideshow } from "./SlideShow";

const SlideShowRenderer = ({
	slideshowData,
	itemId,
}: {
	slideshowData?: SlideData[];
	itemId?: number;
}) => {
	const [containerWidth, setContainerWidth] = useState(0);
	const updateSlideshowDurationInSeconds = useAIFeedbackStore(
		(state) => state.updateSlideshowDurationInSeconds,
	);

	const onLayout = useCallback(
		(event: LayoutChangeEvent) => {
			if (containerWidth === 0 && event.nativeEvent?.layout?.width) {
				setContainerWidth(event.nativeEvent.layout.width);
			}
		},
		[containerWidth],
	);

	const onDurationsLoaded = useCallback(
		(durationInSeconds: number) => {
			if (itemId) {
				updateSlideshowDurationInSeconds(itemId, durationInSeconds);
			}
		},
		[itemId, updateSlideshowDurationInSeconds],
	);

	if (!slideshowData || slideshowData.length === 0) {
		return null;
	}

	return (
		<View onLayout={onLayout} style={{ flex: 1 }}>
			<Slideshow
				data={slideshowData}
				width={containerWidth}
				loading={containerWidth === 0}
				itemId={itemId!}
				onDurationLoaded={onDurationsLoaded}
			/>
		</View>
	);
};

export default SlideShowRenderer;
